/**
 * FB3-46: patterns for developer-facing text that must never reach customers — QR session ids
 * (`ws-…-ch-…`), UUIDs, dotted i18n/event keys (`team.invite.created`), `docs/` paths and
 * UPPER_SNAKE env var names. Shared by the UI sanitizers and the page-level test helper.
 */
export const TECHNICAL_PATTERNS: readonly RegExp[] = [
  /\bws-[0-9a-f-]{8,}-ch-[0-9a-f-]{8,}\b/i,
  /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
  /\b[a-z][a-z0-9]*(?:\.[a-z][a-zA-Z0-9]*){2,}\b/,
  /\bdocs\/[\w./-]+/,
  /\b[A-Z][A-Z0-9]{2,}(?:_[A-Z0-9]+)+\b/,
];

export function looksTechnical(text: string): boolean {
  return TECHNICAL_PATTERNS.some((p) => p.test(text));
}
